import React from "react";
import { Col, ControlLabel, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaBroom, FaMagic } from "react-icons/fa";
import { CustomDate } from "../CustomControls/CustomDateTime";
import { CustomSelect } from "../CustomControls/CustomSelect";
import { PatientPicker } from "../CustomControls/PatientPicker";
import { PractitionerPicker } from "../CustomControls/PractitionerPicker";
import ExportButton from "../Export/ExportButton";

const Filters = ({ filters, masterData, onChange, onApply, onClear, filtersChanged, hasAppliedFilters, resetKey, buttonLoading, actionType }) => {
  const { t } = useTranslation();

  return (
    <form
      className="filters-box"
      onSubmit={(e) => {
        e.preventDefault();
        if (filtersChanged) onApply();
      }}
    >
      <Row className="filters-wrapper">
        <Col lg={9}>
          <Row className="mb-3">
            <Col md={4}>
              <ControlLabel>{t('medicalRecords.prescriptionReports.filters.startDate')}</ControlLabel>
              <CustomDate
                key={`start-${resetKey}`}
                name="StartDate"
                value={filters.StartDate || null}
                onChange={onChange}
              />
            </Col>
            <Col md={4}>
              <ControlLabel>{t('medicalRecords.prescriptionReports.filters.endDate')}</ControlLabel>
              <CustomDate
                key={`end-${resetKey}`}
                name="EndDate"
                value={filters.EndDate || null}
                onChange={onChange}
              />
            </Col>
            <Col md={4}>
              <ControlLabel>{t('medicalRecords.prescriptionReports.filters.healthInsurance')}</ControlLabel>
              <CustomSelect
                defaultValue={filters.HealthInsurance || null}
                onChange={(name, value) => onChange(name, value ? value.title : "")}
                onBlur={() => { }}
                key={`obra-${resetKey}`}
                name="HealthInsurance"
                placeholder={t('medicalRecords.prescriptionReports.filters.healthInsurancePlaceholder')}
                options={masterData?.medicalInsurances}
                isClearable={true}
              />
            </Col>
          </Row>

          <Row>
            <Col md={4}>
              <ControlLabel>{t('medicalRecords.prescriptionReports.filters.clinicalHistory')}</ControlLabel>
              <PatientPicker
                autoFocus
                id="MedicalRecordNumber"
                name="MedicalRecordNumber"
                multiple={false}
                placeholder={t("filters.patient")}
                onChange={(name, value) => onChange(name, value?.medicalRecordNumber)}
                value={filters.MedicalRecordNumber ? [filters.MedicalRecordNumber] : []}
              />
            </Col>
            <Col md={4}>
              <ControlLabel>{t('medicalRecords.prescriptionReports.filters.professional')}</ControlLabel>
              <PractitionerPicker
                id="practitioner"
                key={`profesional-${resetKey}`}
                name="Practitioner"
                value={filters.Professional}
                multiple={false}
                onlyDoctor={true}
                placeholder={t('medicalRecords.prescriptionReports.filters.professionalPlaceholder')}
                onChange={(name, selected) =>
                  onChange(name, selected ? selected.fullName : "")
                }
              />
            </Col>
          </Row>
        </Col>

        {/* Caja de acciones a la derecha */}
        <Col lg={3} className="d-flex flex-column">
          <div className="action-box">
            <h6 className="mb-3">{t('medicalRecords.prescriptionReports.actions.title')}</h6>
            <div className="action-buttons-horizontal">
              {buttonLoading ? (
                <button className="btn btn-receta-action btn-receta-loading" disabled>
                  <i className="fa fa-spinner fa-spin" />
                  <span className="btn-receta-loading-text">
                    {actionType === "clear"
                      ? t('medicalRecords.prescriptionReports.actions.clearing')
                      : t('medicalRecords.prescriptionReports.actions.loading')}
                  </span>
                </button>
              ) : (
                <button
                  className={`btn btn-receta-action ${filtersChanged
                    ? "btn-primary"
                    : hasAppliedFilters
                      ? "btn-outline-primary"
                      : "btn-secondary"
                    }`}
                  onClick={filtersChanged ? onApply : onClear}
                  disabled={!filtersChanged && !hasAppliedFilters}
                >
                  {filtersChanged ? (
                    <>
                      <FaMagic className="filter-icon" />
                      {t('medicalRecords.prescriptionReports.actions.applyFilters')}
                    </>
                  ) : (
                    <>
                      <FaBroom className="filter-icon" />
                      {t('medicalRecords.prescriptionReports.actions.clearFilters')}
                    </>
                  )}
                </button>
              )}

              <ExportButton filters={filters} context="prescription" />
            </div>
          </div>
        </Col>
      </Row>
    </form>
  );
};

export default Filters;
